export default __webpack_public_path__ + "static/heromegantheestalion-686f277f8741bec9e0f80a8d4b0583b5.jpg";